export class FaqSearchInputChange {
    constructor(optionalOptions = {}) {
        this._inputs = document.querySelectorAll('.user-profile-settings-faq--search .input--search');
        if (!this._inputs) {
            this.destructor();
            return true;
        }

        let lists
        let elements

        for (let i = 0; i < this._inputs.length; ++i) {
            let input = this._inputs[i];

            ['input', 'change'].forEach(function(ev) {
                input.addEventListener(ev, (e) => {
                    input.closest('.base-input-wrp--search').classList.add('edited')
                    lists = document.querySelector('.user-profile-settings--lists')
                    if (lists) {
                        if (input.value === '') {
                            elements = lists.querySelectorAll('.user-profile-settings-list--item')
                            for (let ii = 0; ii < elements.length; ++ii) {
                                elements[ii].classList.remove('hidden')
                            }

                            return true;
                        }

                        elements = lists.querySelectorAll('.user-profile-settings-list--item')
                        for (let ii = 0; ii < elements.length; ++ii) {
                            elements[ii].classList.add('hidden')
                        }

                        elements = lists.querySelectorAll('.user-profile-settings--name')
                        for (let iii = 0; iii < elements.length; ++iii) {
                            if (elements[iii].textContent.toLowerCase().includes(input.value.toLowerCase())) {
                                elements[iii].closest('.user-profile-settings-list--item').classList.remove('hidden');
                            }
                        }
                    }
                })
            });

        }
    }

    destructor() {
        this._inputs = null;
    }
}

export default new FaqSearchInputChange();